// src/libs/Pagination.js

import React from 'react';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa6';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const generatePageNumbers = () => {
    const pageNumbers = [];
    const totalNumbers = 5; // Total page numbers to show in pagination
    const totalBlocks = totalNumbers + 2; // Total blocks to show (including first and last)

    if (totalPages > totalBlocks) {
      const startPage = Math.max(2, currentPage - 1);
      const endPage = Math.min(totalPages - 1, currentPage + 1);

      let pages = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);

      const hasLeftSpill = startPage > 2;
      const hasRightSpill = (totalPages - endPage) > 1;
      const spillOffset = totalNumbers - (pages.length + 1);

      if (hasLeftSpill && !hasRightSpill) {
        const extraPages = Array.from({ length: spillOffset }, (_, i) => startPage - spillOffset + i);
        pages = ['...', ...extraPages, ...pages];
      } else if (!hasLeftSpill && hasRightSpill) {
        const extraPages = Array.from({ length: spillOffset }, (_, i) => endPage + i + 1);
        pages = [...pages, ...extraPages, '...'];
      } else if (hasLeftSpill && hasRightSpill) {
        pages = ['...', ...pages, '...'];
      }

      pageNumbers.push(1, ...pages, totalPages);
    } else {
      pageNumbers.push(...Array.from({ length: totalPages }, (_, i) => i + 1));
    }

    return pageNumbers;
  };

  return (
    <div className="flex items-center gap-3">
      <button
        className="rounded-md border min-h-[30px] min-w-[30px] hover:bg-gray-100 flex justify-center items-center"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <FaAngleLeft />
      </button>
      {generatePageNumbers().map((page, index) => (
        <button
          key={index}
          className={`rounded-md border min-h-[30px] min-w-[30px] ${page === currentPage ? 'bg-[#0D6EFD] text-white' : 'hover:bg-gray-100'}`}
          onClick={() => typeof page === 'number' && onPageChange(page)}
          disabled={page === '...'}
        >
          {page}
        </button>
      ))}
      <button
        className="rounded-md border min-h-[30px] min-w-[30px] hover:bg-gray-100 flex justify-center items-center"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage >= totalPages}
      >
        <FaAngleRight />
      </button>
    </div>
  );
};

export default Pagination;